import { ChangeEvent, useEffect } from 'react';

import { DevHubMenuItem, DevHubTextField } from '@devxdiscover/devhub-ui';
import {
  SelectFieldOptionItem,
  SelectFieldOptions,
  SelectFieldOptionsList,
} from './types/appBulkEditTypes';
import { useAppBulkEditContext } from './context/AppBulkEditContext';
import { ValidationType } from './AppBulkEdit';

type AppBulkEditSelectFieldsProps = {
  setValidationHasError: (value: ValidationType) => void;
};

/**
 * Component for selecting fields to edit in bulk edit.
 * @param props - The component props.
 * @param props.setValidationHasError - Function to set validation error state.
 */
const AppBulkEditSelectFields = ({
  setValidationHasError,
}: AppBulkEditSelectFieldsProps): JSX.Element => {
  const { field, setField, setProperty } = useAppBulkEditContext();

  const handleChange = (event: ChangeEvent<{ value: unknown }>): void => {
    setField(event.target.value as SelectFieldOptions);
  };

  useEffect(() => {
    const hasError = field?.length === 0;
    setValidationHasError({
      hasError: hasError,
      errorMessage: hasError ? 'Select field to proceed' : '',
    });
    const prop = SelectFieldOptionsList.find(
      option => option.value === field,
    )?.property;
    if (prop) {
      setProperty(prop);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field]);

  return (
    <div>
      <DevHubTextField
        name="editField"
        size="small"
        select
        variant="outlined"
        fullWidth={false}
        onChange={handleChange}
        label="Select the field that needs to be edited"
        value={field}
      >
        {SelectFieldOptionsList?.map((option: SelectFieldOptionItem) => {
          return (
            <DevHubMenuItem key={option?.value} value={option?.value}>
              {option?.label}
            </DevHubMenuItem>
          );
        })}
      </DevHubTextField>
    </div>
  );
};

export default AppBulkEditSelectFields;
